import { render, staticRenderFns } from "./PasswortAendern.vue?vue&type=template&id=a661a76c&scoped=true&"
import script from "./PasswortAendern.vue?vue&type=script&lang=js&"
export * from "./PasswortAendern.vue?vue&type=script&lang=js&"
import style0 from "./PasswortAendern.vue?vue&type=style&index=0&id=a661a76c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a661a76c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCol,VForm,VRow,VSnackbar})
